export function wip () {
  alert('Ooops, this feature isn\'t available yet... Feel free to contribute on our Github repository (lhsazevedo/vuetify-material-auth).')
}
